import { Component, Input, NgModule } from '@angular/core';
import { Employee, Farm, Product } from '../../../models/types';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProfilePageService } from '../../services/profile-page.service';
@Component({
  selector: 'app-add-employee-modal',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule],
  templateUrl: './add-employee-modal.component.html',
  styleUrl: './add-employee-modal.component.scss'
})
export class AddEmployeeModalComponent {
  @Input() farm!: Farm;

  newEmployee: Employee = {
    employeeID: 0,
    name: '',
    surname: '',
    employeeDescription: ''
  };

  constructor(
    public activeModal: NgbActiveModal,
    private profilePageService: ProfilePageService
  ) {}

  addNewEmployee(): void {
    this.profilePageService.addEmployee(this.farm.farmID, this.newEmployee).subscribe(
      (response) => {
        console.log('Employee added successfully:', response);
        // Assuming response handling here, like adding to local employees array
        //this.employees.push(employee);
        //this.resetForm(); 
        this.newEmployee = { employeeID: 0, name: '', surname: '', employeeDescription: '' };
        this.activeModal.close(); // Close the modal after successful add 
        window.location.reload();
      },
      (error) => {
        console.error('Error adding employee:', error);
        // Handle error adding employee
      }
    );
    //console.log('List of employees:', this.employees);
  }

  cancel() {
    this.activeModal.dismiss('cancel');
  }
}
